var React = require('react');

function YoutubeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m3.38086 1.04883s5.43314-1.04883 9.61914-1.04883 9.6191 1.04883 9.6191 1.04883l.0039.00586c1.9424.30628 3.3741 1.97893 3.377 3.94531v6 .002 5.998.002c-.0021 1.9677-1.435 3.6417-3.3789 3.9472l-.002.002s-5.4331 1.0508-9.6191 1.0508-9.61914-1.0508-9.61914-1.0508l-.00391-.0059c-1.94165-.3062-3.37310676-1.9777-3.37695-3.9433v-.002-5.998-.002-6c0-1.99238 1.46066-3.63064 3.36719-3.93555zm14.61914 9.95117-8-4.60156v9.20316z","fill":"#3f3f3f","fillRule":"evenodd"}));
}

YoutubeInline.defaultProps = {"fill":"none","height":"23","viewBox":"0 0 26 23","width":"26"};

module.exports = YoutubeInline;

YoutubeInline.default = YoutubeInline;
